<template>
  <details class="vchy-package-size-selector" open>
    <summary v-show="false" id="PACAKAGE_SIZE_SELECTOR" ref="accordion">
      <h2 class="text-small-em">{{ selectedPackageSize }}</h2>
      <svg
        class="vchy-package-size-selector__toggle"
        aria-hidden="true"
        width="24"
        height="24"
      >
        <use href="/assets/sprite/icons.svg#arrow-black"></use>
      </svg>
    </summary>
    <div
      class="vchy-details__contents"
      :aria-label="packageSizeSelectorAriaLabel"
      role="listbox"
    >
      <div class="vchy-package-size-selector__list pt-xs">
        <div
          v-for="opt in packageOptions"
          :key="opt.ean"
          :id="opt.ean"
          role="option"
          :aria-selected="opt.selected"
          tabindex="0"
          @click="selectOption(opt)"
          @keypress.space="selectOption(opt)"
          @keypress.enter="selectOption(opt)"
        >
          <span class="text-small-em">{{ opt.description }}</span>
          <span class="is-sr-only"> {{ selectedPackageSize }}</span>
        </div>
      </div>
    </div>
  </details>
</template>

<script>
import { eventBus } from 'EventBus/';
import { busName } from 'Directives/variant-selector/variant-selector';
import { pushEvent } from 'Utils/datalayer';

export default {
  name: 'vch-package-size-selector',
  props: {
    options: {
      type: String,
      required: true,
    },
    defaultOption: {
      type: String,
      required: true,
    },
    modalOpen: {
      type: Boolean,
      default: false,
    },
    productItemId: {
      type: String,
    },
    varintItemId: {
      type: String,
    },
    packageSizeSelectorAriaLabel:{
      type: String,
      default: 'PACAKAGE_SIZE_SELECTOR'
    },
  },
  data() {
    return {
      selectedPackageSize: null,
      productItemIds: this.productItemId,
      varintItemIds: this.varintItemId,
    };
  },
  computed: {
    packageOptions() {
      const opts = JSON.parse(this.options);
      return opts.map((o) => ({
        ...o,
        selected: o.description === this.selectedPackageSize,
      }));
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.selectedPackageSize = this.defaultOption;
    });
    this.varientComponentAPI();
  },
  methods: {
    selectOption(opt) {
      this.varintItemIds = `{${opt.varintItemId}}`;
      this.productItemIds = `{${opt.productItemId}}`;
      if (opt.varintItemId != '' && opt.productItemId != '') {
        this.varientComponentAPI();
      }
      this.selectedPackageSize = opt.description;
      if (!this.modalOpen) {
        pushEvent(opt.click);
      }
      eventBus.$emit(`${busName}::selected`, opt.ean);
      // Simulate a click on the summary so it animates close
     // this.$refs.accordion.click();

      // modifying Refapp analytics events product-id to use productEAN that is stored within variant
      window.eventBus.$emit('rfp-product-variant-data-update', {
        ean: opt.ean,
      });
    },
    varientComponentAPI() {
      if (this.productItemId !== '' && this.varintItemId !== '') {
        setTimeout(() => {
          window.eventBus.$emit('rfp-mctb-has-varient-component', {
            productItemId: this.productItemIds?.toUpperCase(),
            varintItemId: this.varintItemIds?.toUpperCase(),
          });
        }, 100);
      }
    },
  },
};
</script>

<style lang="scss" src="./package-size-selector.scss"></style>
